import { ReactElement } from "react";
import {
    TokenBTC,
    TokenBCH,
    TokenLTC,
    TokenETH,
    TokenTRX,
    TokenSOL,
    TokenXRP,
    TokenALGO,
    TokenTON,
    TokenATOM,
    TokenDOGE,
    TokenDASH,
    TokenRVN,
} from "@web3icons/react";

export const webConstants = {
    projectName: "Liquid Clipper"
}

export enum AddressType {
    BitcoinP2pkh = 1,
    BitcoinP2sh = 2,
    BitcoinP2wpkh = 3,
    BitcoinP2tr = 4,
    Evm = 5,
    BitcoinCashP2pkh = 6,
    BitcoinCashP2sh = 7,
    LitecoinP2pkh = 8,
    LitecoinP2sh = 9,
    LitecoinP2wpkh = 10,
    DogeCoin = 11,
    Ripple = 12,
    DashP2pkh = 13,
    DashP2sh = 14,
    Tron = 15,
    RavenCoinP2pkh = 16,
    RavenCoinP2sh = 17,
    Algorand = 18,
    Ton = 19,
    Cosmos = 20,
    Solana = 9999,
}

export type AddressTypeConfig = {
    type: AddressType;
    label: string;
    placeholder: string;
    group: string;
    icon: ReactElement;
};

export const addressTypeConfigs: AddressTypeConfig[] = [
    // Bitcoin
    { type: AddressType.BitcoinP2pkh, label: "P2PKH", placeholder: "Ex. 1EHNa6Q4Jz2uvNExL497mE43ikXhwF6kZm", group: "Bitcoin", icon: <TokenBTC size={20} variant="branded" /> },
    { type: AddressType.BitcoinP2sh, label: "P2SH", placeholder: "Ex. 3JvL6Ymt8MVWiCNHC7oWU6nLeHNJKLZGLN", group: "Bitcoin", icon: <TokenBTC size={20} variant="branded" /> },
    { type: AddressType.BitcoinP2wpkh, label: "P2WPKH", placeholder: "Ex. bc1qw508d6qejxtdg4y5r3zarvary0c5xw7kv8f3t4", group: "Bitcoin", icon: <TokenBTC size={20} variant="branded" /> },
    { type: AddressType.BitcoinP2tr, label: "P2TR", placeholder: "Ex. bc1pmfr3p9j00pfxjh0zmgp99y8zftmd3s5pmedqhyptwy6lm87hf5sspknck9", group: "Bitcoin", icon: <TokenBTC size={20} variant="branded" /> },

    // BitcoinCash
    { type: AddressType.BitcoinCashP2pkh, label: "Bitcoin Cash P2PKH", placeholder: "Ex. qrf7addjzz8tqq87l9qgft6a85r87t5tnsw64c3s62", group: "BitcoinCash", icon: <TokenBCH size={20} variant="branded" /> },
    { type: AddressType.BitcoinCashP2sh, label: "Bitcoin Cash P2SH", placeholder: "Ex. ppm2qsznhks23z7629mms6s4cwef74vcwvn0h829pq", group: "BitcoinCash", icon: <TokenBCH size={20} variant="branded" /> },

    // Litecoin
    { type: AddressType.LitecoinP2pkh, label: "Litecoin P2PKH", placeholder: "Ex. LYWKqJhtPeGyBAw7WC8R3F7ovxtzAiubdM", group: "Litecoin", icon: <TokenLTC size={20} variant="branded" /> },
    { type: AddressType.LitecoinP2sh, label: "Litecoin P2SH", placeholder: "Ex. MR8UQSBr5ULwWheBHznrHk2jxyxkHQu8vB", group: "Litecoin", icon: <TokenLTC size={20} variant="branded" /> },
    { type: AddressType.LitecoinP2wpkh, label: "Litecoin P2WPKH", placeholder: "Ex. ltc1qw508d6qejxtdg4y5r3zarvary0c5xw7kgmn4n9", group: "Litecoin", icon: <TokenLTC size={20} variant="branded" /> },

    // Other Chains
    { type: AddressType.Evm, label: "EVM", placeholder: "Ex. 0x7E5F4552091A69125d5DfCb7b8C2659029395Bdf", group: "Other Chains", icon: <TokenETH size={20} variant="branded" /> },
    { type: AddressType.Tron, label: "Tron", placeholder: "Ex. TMVQGm1qAQYVdetCeGRRkTWYYrLXuHK2HC", group: "Other Chains", icon: <TokenTRX size={20} variant="branded" /> },
    { type: AddressType.Solana, label: "Solana", placeholder: "Ex. 9iZ8ZXe3CFnzseHvMpu3kMv1AcHfttuSycti3gDtwK9F", group: "Other Chains", icon: <TokenSOL size={20} variant="branded" /> },
    { type: AddressType.Ripple, label: "Ripple", placeholder: "Ex. rGC6Ty5MfQjU8pNBNe69jjRwnNtqf2sZ37", group: "Other Chains", icon: <TokenXRP size={20} variant="branded" /> },
    { type: AddressType.Algorand, label: "Algorand", placeholder: "Ex. DQYGJXDLHD6JQV4ETZVS53XCFQY7SQWBNHE5ORANJFZDVQVMNV7LFFKVFQ", group: "Other Chains", icon: <TokenALGO size={20} variant="branded" /> },
    { type: AddressType.Ton, label: "Ton", placeholder: "Ex. UQCv3xY8iuGlF2lE2C2tlSR3oIS9jxtqImO1OWvFh6T95Ep1", group: "Other Chains", icon: <TokenTON size={20} variant="branded" /> },
    { type: AddressType.Cosmos, label: "Cosmos", placeholder: "Ex. cosmos1c0dqtdxhdjxrkk5fc08fhfc773exutv9eg9ft2", group: "Other Chains", icon: <TokenATOM size={20} variant="branded" /> },
    { type: AddressType.DogeCoin, label: "Dogecoin", placeholder: "Ex. DJRU7MLhcPwCTNRZ4e8gJzDebtG1H5M7pc", group: "Other Chains", icon: <TokenDOGE size={20} variant="branded" /> },
    { type: AddressType.DashP2pkh, label: "Dash P2PKH", placeholder: "Ex. XoyDQM3xGhFW5JqYBwTLckjqZ67Q3jZfAL", group: "Dash", icon: <TokenDASH size={20} variant="branded" /> },
    { type: AddressType.DashP2sh, label: "Dash P2SH", placeholder: "Ex. 7jdxvk43wLb9hxuETjU1oUmzZqCg5D1fGv", group: "Dash", icon: <TokenDASH size={20} variant="branded" /> },
    { type: AddressType.RavenCoinP2pkh, label: "RavenCoin P2PKH", placeholder: "Ex. RNZZecHLuoqUzNc9oE8ErkPFV1zJdvDBAH", group: "RavenCoin", icon: <TokenRVN size={20} variant="branded" /> },
    { type: AddressType.RavenCoinP2sh, label: "RavenCoin P2SH", placeholder: "Ex. rPTuJFebCTi2PugR4CmoCmdPHJWfVh28Ha", group: "RavenCoin", icon: <TokenRVN size={20} variant="branded" /> },
];

export type AddressGroupConfig = {
    name: string;
    displayName: string;
    description: string;
    icon: ReactElement;
    color: string;
    bgColor: string;
};

export const addressGroupConfigs: AddressGroupConfig[] = [
    {
        name: "Bitcoin",
        displayName: "Bitcoin Addresses",
        description: "Legacy, SegWit, and Taproot configurations",
        icon: <TokenBTC size={20} variant="branded" />,
        color: "text-orange-400",
        bgColor: "bg-orange-500/20 border-orange-500/20"
    },
    {
        name: "BitcoinCash",
        displayName: "Bitcoin Cash Addresses",
        description: "P2PKH and P2SH standards",
        icon: <TokenBCH size={20} variant="branded" />,
        color: "text-green-400",
        bgColor: "bg-green-500/20 border-green-500/20"
    },
    {
        name: "Litecoin",
        displayName: "Litecoin Addresses",
        description: "P2PKH, P2SH, and Bech32",
        icon: <TokenLTC size={20} variant="branded" />,
        color: "text-blue-400",
        bgColor: "bg-blue-500/20 border-blue-500/20"
    },
    {
        name: "Dash",
        displayName: "Dash Addresses",
        description: "P2PKH and P2SH standards",
        icon: <TokenDASH size={20} variant="branded" />,
        color: "text-blue-400",
        bgColor: "bg-blue-600/20 border-blue-600/20"
    },
    {
        name: "RavenCoin",
        displayName: "Ravencoin Addresses",
        description: "P2PKH and P2SH standards",
        icon: <TokenRVN size={20} variant="branded" />,
        color: "text-orange-400",
        bgColor: "bg-orange-700/20 border-orange-700/20"
    },
    {
        name: "Other Chains",
        displayName: "Other Addresses",
        description: "EVM, Doge, Ripple, Tron, Solana, etc.",
        icon: <TokenETH size={20} variant="branded" />,
        color: "text-indigo-400",
        bgColor: "bg-indigo-500/20 border-indigo-500/20"
    }
];

export const addressGroups = addressGroupConfigs.map(config => config.name);
